import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface AgricolaReportConfirmData {
  requestId: number | string;
}

@Component({
  selector: 'app-agricola-report-confirm-dialog',
  templateUrl: './agricola-report-confirm-dialog.component.html',
  styleUrls: ['./agricola-report-confirm-dialog.component.css'],
  standalone: false
})
export class AgricolaReportConfirmDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: AgricolaReportConfirmData,
    private readonly dialogRef: MatDialogRef<AgricolaReportConfirmDialogComponent, boolean>
  ) {}

  cancel(): void {
    this.dialogRef.close(false);
  }

  accept(): void {
    // Resolving with `true` lets the caller route the user to the report queue.
    this.dialogRef.close(true);
  }
}
